
import * as AdminDashboardActions from './../../../actions/admin/dashboard_actions';
import * as AdminSettingAactions from './../../../actions/admin/adminSetting_action';

import * as UserActions from './../../../actions/user_actions';

import extend from 'lodash/extend';
// import * as SettingScreen from './../actions/settingScreen';


export var AdminDashboard = (state = {
    AdminDashboardData: null,
    SelectAdmin: null,
    AdminDeactivateRequestResponse: null
}, action) => {

    switch (action.type) {
        // // Uncomment below block only if you want to persist store data
        case "@@redux/INIT": {
        }
        case 'persist/REHYDRATE': {
            if (action.payload && action.payload.AdminDashboard) {

                return extend({}, state, action.payload.AdminDashboard);
            } else {
                return state;
            }
        }
            break;
        case AdminDashboardActions.ADMIN_DASHBOARD_DATA:
            {
                return extend({}, state, { AdminDashboardData: action.data });
            }
            break;
        case AdminDashboardActions.ADMIN_DASHBOARD_DETAILS_FAIL:
            {
                return extend({}, state, { AdminDashboardData: action.data });
            }
            break;

        case AdminSettingAactions.ADMIN_SELECT_DATA:
            {
                return extend({}, state, { SelectAdmin: action.data });
            }
            break;
        case AdminSettingAactions.ADMIN_SELECT_DETAILS_FAIL:
            {
                return extend({}, state, { SelectAdmin: action.data });
            }
            break;

        case AdminSettingAactions.ADMIN_REQUEST_TO_DEACTIVATE_RESPONSE_DATA:
            {
                return extend({}, state, { AdminDeactivateRequestResponse: action.data });
            }
            break;
        case UserActions.USER_LOG_OUT: {
           
                return extend({}, state, {
                  AdminDashboardData: null,
                  SelectAdmin: null,
                  AdminDeactivateRequestResponse: null
                })
            }
         break;

        default:
            return state;
    }
};



/** WEBPACK FOOTER **
 ** ./src/reducers/admin/dashboard/dashboard_reducer.js
 **/